/** Screen-size breakpoints shared by the components that need them in code;
 * the CSS uses the same widths. */

import { useEffect, useState } from "react";

/** Phones: the sidebar becomes a menu that slides in over the page. */
export const PHONE = "(max-width: 768px)";

/** Whether a media query matches, following it as the window is resized. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia?.(query).matches ?? false);

  useEffect(() => {
    const list = window.matchMedia?.(query);
    if (!list) return;
    const update = () => setMatches(list.matches);
    update();
    list.addEventListener("change", update);
    return () => list.removeEventListener("change", update);
  }, [query]);

  return matches;
}
